import React, {memo, useContext} from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import ExposureNeg1Icon from '@material-ui/icons/ExposureNeg1';
import Tr from 'translations/Translations'
import deepEq from 'fast-deep-equal'
import {Collapse} from "@material-ui/core";

function PurchaserDataTogetherList(
    {
        id,
        formikProps,
        index,
        removePurchaser
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const editable = getObjectValue('_editable', formikProps.values, true);
    const {getDict} = useContext(FormTranslationContext)

    return (<>
        <GridBlock justify="space-between">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
            <Button disabled={!editable} variant="outlined" Icon={ExposureNeg1Icon} onClick={() => removePurchaser(index)}>{Tr("remove_purchaser_x", {x: index + 1})}</Button>
        </GridBlock>
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("name")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("branch")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("nationalIdNumber")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("street")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("city")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("postCode")}
            required
        />
        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("country")}
            items={getDict("SL.MT.005")}
            required
            unmountOnExit
        />
        <Collapse in={gVal("country") === "PL"}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("state")}
                items={getDict("SL.MT.007")}
                required
                unmountOnExit
            />
        </Collapse>
        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("nuts3")}
            items={getDict("SL.MT.004")}
            unmountOnExit
            prefixLabelsWithKeys
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("phone")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("fax")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("email")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("www")}
            required
        />
    </>)
}

PurchaserDataTogetherList.propTypes = {};
// export default PurchaserDataTogetherList;
export default memo(PurchaserDataTogetherList, (prevProps, nextProps) => {
    const id = nextProps.id;
    if (prevProps.formikProps && nextProps.formikProps) {
        const pv = getObjectValue(id, prevProps.formikProps.values, null);
        const nv = getObjectValue(id, nextProps.formikProps.values, null);
        if (pv === nv) {
            const pe = getObjectValue(id, prevProps.formikProps.errors, null);
            const ne = getObjectValue(id, nextProps.formikProps.errors, null);
            return pe === ne && deepEq(pe, ne);
        }
    }
    return false;
})

